const AnimatedChart = () => {
  const bars = [
    { height: "110px", delay: "50ms" },
    { height: "160px", delay: "120ms" },
    { height: "200px", delay: "200ms" },
    { height: "90px", delay: "280ms" },
    { height: "130px", delay: "360ms" },
  ];

  return (
    <div 
      className="relative h-[220px] rounded-xl overflow-hidden border-neon"
      style={{
        background: `
          radial-gradient(600px 260px at 20% 0%, hsl(var(--primary) / 0.25), transparent 60%),
          radial-gradient(400px 200px at 80% 100%, hsl(var(--secondary) / 0.15), transparent 60%),
          linear-gradient(180deg, hsl(var(--glass-strong)), hsl(var(--background)))
        `
      }}
    >
      {/* Scan line effect */}
      <div 
        className="absolute inset-x-0 h-[2px] bg-gradient-to-r from-transparent via-primary/40 to-transparent"
        style={{ animation: "scan-line 4s linear infinite" }}
      />
      
      <div className="absolute inset-x-0 bottom-0 h-[1px] bg-gradient-to-r from-transparent via-primary/60 to-transparent" />
      
      <div className="absolute bottom-4 left-[18px] right-[18px] flex gap-[14px] items-end">
        {bars.map((bar, i) => (
          <div
            key={i}
            className="flex-1 rounded-t-lg origin-bottom relative"
            style={{
              height: bar.height,
              background: "linear-gradient(180deg, hsl(var(--primary)), hsl(var(--primary) / 0.5))",
              boxShadow: "0 0 20px hsl(var(--primary) / 0.6), 0 6px 18px hsl(var(--primary) / 0.4)",
              animation: "grow-bar 1.1s ease forwards",
              animationDelay: bar.delay,
              transformOrigin: "bottom",
            }}
          >
            <div 
              className="absolute inset-0 rounded-t-lg"
              style={{
                background: "linear-gradient(180deg, transparent, hsl(var(--primary) / 0.3))",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AnimatedChart;
